<template>
    <div class="container">
        <img class="img" src="../../assets/contract_success.png" />
        <div style="font-size: 15px; text-align: center; color: #888">
            恭喜你，合同签署成功！
        </div>
        <div class="p_title"  @click="onPress">
            请手动返回应用内继续
        </div>
    </div>
</template>


<script>
export default ({
    data() {
        return {
            id: -1,
            gender: -1,
            token: ''
        }
    },

    created() {
        this.checkURLParams();
    },

    methods: {
        checkURLParams() {
            const url = window.location.href;
            const z = url.split('?');
            let p = {};
            try {
                const k = z[1].split('&');
                k.forEach(item => {
                    const m = item.split('=');
                    p[m[0]] = m[1];
                })
                this.id = p.id;
                this.gender = p.gender;
                this.token = p.token;
            } catch(e) {}
        },

        click(page) {
            // alert(this.token);
            // console.log('tiktok tiktok really - - - - - - >', this.token);
            // return;
            const p = {};
            // p.page = 'FreeChat';
            p.page = page;
            p.id = '214791';
            p.data = {};
            // p.tt = this.id;
            // p.hh = this.gender;
            const z = JSON.stringify(p);
            window.ReactNativeWebView.postMessage(z);
        },

        onPress() {
            // console.log('tiktok tiktok really - fwefwef- - - - - >');
            // const url = `samsungapps://`;
            // const url = `forcatsmiyou://`;
            // window.location.href = url;
        }
    }
})
</script>



<style scoped>
.container {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
}
.p_title {
    font-size: 18px;
    font-weight: 600px;
    align-self: center;
    justify-content: center;
    margin-bottom: 100px;
    margin: 40px 20px;
    background-color: #7F5AFF;
    color: #FFF;
    width: 70%;
    height: 40px;
    text-align: center;
    line-height: 40px;
    border-radius: 20px;
    /* font-style: italic */
}

.img {
    width: 60%;
    margin-top: 80px;
    margin-left: 20%;
}
</style>